$(document).ready(function() {
  var $productGrid = document.querySelector('#ProductGridContainer') || null;

  window.initPartnerSlider = function() {
    $('.partner_slider_new').on('init', function(event, slick) {
      const $initPartnerSlider = slick.$slider[0];

      // Timeout needed for slow loading
      setTimeout(() => {
        customSlickSlider();
        setInitialSlideVisibility($initPartnerSlider);
      }, 500);
    });

    $('.partner_slider_new').each(function(key, val) {
      var id1 = "";
      var sliderId_1 = "";
      var id1 =  $(this).attr('id');
      var sliderId_1 = '#' + id1;
      if ( $(sliderId_1).hasClass('slick-initialized') ) {
      } else {
        $(sliderId_1).slick({
          slidesToShow: 4,
          slidesToScroll: 3,
          rtl:true,
          infinite: false,
          prevArrow: $("#l_"+id1),
          nextArrow: $("#r_"+id1),
          variableWidth: true,
          speed: 1000,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                infinite: false,
                variableWidth: true,
                speed: 1000,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
                variableWidth: true,
                speed: 1000,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                speed: 500,
              }
            },
            {
              breakpoint: 480,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                speed: 500,
              }
            }
          ]
        });

        // Remove aria-describedby from slick slides
        setTimeout(() => {
          const slickSlides = $(sliderId_1).find('.slick-list .slick-slide');
          adaFormatSlickSlides(slickSlides);
        }, 250);
      }

      $("#l_"+id1).hide();
      customSlickSlider();
      $(sliderId_1).on('afterChange', function (event, slick, currentSlide) {
        const $partnerSlider = slick.$slider[0];
        setSlideVisibility($partnerSlider);
        if (currentSlide === 0) {
          $("#l_"+id1).hide();
        }
        else {
          $("#l_"+id1).show();
        }
      });
    });
  }
  window.initPartnerSlider();

  /* Starts Product Slider - Karthikeyan */
  //  setInterval(function() {
  window.initProductSlider = function() {
    $('.product-list-contain').on('init', function(event, slick) {
      const $initProductListSlider = slick.$slider[0];

      // Timeout needed for slow loading
      setTimeout(() => {
        customSlickSlider();
        setInitialSlideVisibility($initProductListSlider);
      }, 500);
    });

    $('.product-list-contain').each(function(key, val) {
      var id = $(this).attr('id');
      var sliderId = '#' + id;
      $(sliderId).not('.slick-initialized').slick({
        variableWidth: true,
        dots: true,
        infinite: true,
        rtl:true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $(this).parent().find('.prev'),
        nextArrow: $(this).parent().find('.next'),
        appendDots: $(this).parent().find('.dots-slider'),
        dotsClass: 'slick-dots apl-section-carousel-dots',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            }
          }
        ]
      });

      $('.product-list-contain').on('afterChange', function (event, slick) {
        const $productListSlider = slick.$slider[0];
        setSlideVisibility($productListSlider);
      });

      // Remove aria-describedby from slick slides
      setTimeout(() => {
        const slickSlides = $(sliderId).find('.slick-list .slick-slide');
        adaFormatSlickSlides(slickSlides);
      }, 250);
    })
  }
  window.initProductSlider();
  /* Ends Product Slider - Karthikeyan */

    $(document).on('click', '.freq-select-products', function() {
        if ($(".button-cart-frequent").attr("product-list") == "Cart Page") {
            var productList = "ATTACH :: Cart Page";
        } else {
            var mpn_handle = $("#mpn_handle").val();
            var productList = "Shopify Rec :: " + mpn_handle;
        }
        localStorage.setItem("product-click", productList);
    });

    $(document).on('change', '.frequent-products-checkbox', function() {
        var checkLength = $("input[name='frequent-products-pdp']:checked").length;
        $("#checked-products").text(checkLength);
        if (checkLength == 0) {
            $('#card-button').prop("disabled", true);
        } else {
            $('#card-button').prop("disabled", false);
        }
        var product_id = $(this).val();
        var prodtitle = $("#title_" + product_id).val();
        var prodMPN = $("#product_mpn_handle_" + product_id).val();
        var prodType = $(".card_product_category_" + product_id).val();
        var prodCurrency = $(".card_product_currency_" + product_id).attr("value");
        var prodPrice = $(".card_product_price_" + product_id).attr("value");
        var compareprice = $(".card_product_compare_" + product_id).attr("value");
        var prodSku = $(".card_product_sku_" + product_id).attr("value");
        prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g, ""));
        prodPrice = parseFloat(prodPrice);
        var prodSku = $(".card_product_sku_" + product_id).attr("value");
        if ($(".button-cart-frequent").attr("product-list") == "Cart Page") {
            var productList = "ATTACH :: Cart Page";
        } else {
            var mpn_handle = $("#mpn_handle").val();
            var productList = "Shopify Rec :: " + mpn_handle;
        }
        localStorage.setItem("product-click", productList);
        dataLayer.push({
            'ecommerce': null
        });
        dataLayer.push({
            'event': 'select_item',
            'ecommerce': {
                'item_list_name': productList,
                'items': [{
                    'item_id': prodSku,
                    'item_name': prodtitle,
                    'item_category': prodType,
                    'price': prodPrice,
                    'quantity': 1,
                }]
            }
        });
    });


  $(document).on('click', '#card-button', async function (event) {
    event.preventDefault();

        var $CTOcartDrawer = $('cto-cart-drawer');
        $('.button-cart-frequent').attr('aria-disabled', true);
        $('.button-cart-frequent').addClass('loading');
        $('.loading-overlay__spinner-frequent').removeClass('hidden');
        var frequentProducts = [];
        var frequentProducts_ga = [];
        var tax_total_quantity = 0;
        var quncheck = [];
        var prodTitle = [];
        var value_price = 0;
        var prodCurrency = $("#prod_currency").val();
        $.each($("input[name='frequent-products-pdp']:checked"), function() {
            /* Order Product Limits - Karthikeyan */
            var prodId = $("#product_id_" + $(this).val()).val();
            var prodQuant = 1;
            var prodMaxqut = $("#product_max_quantity_" + $(this).val()).val();
            var prodtitle = $("#title_" + $(this).val()).val();
            var prodMPN = $("#product_mpn_handle_" + $(this).val()).val();
            let prod_handle = $("#card_product_handle_" + $(this).val()).val();
            var prodPreorder = $("#card_product_preorder_" + $(this).val()).val();
            var prodPreorderMessage = $("#card_product_preorder_message_" + $(this).val()).val();
            var prodTradeIn = $("#card_product_tradein_" + $(this).val()).val();
            var isMainProduct = $(this).hasClass('js-is-main-product');
            var prodSku = $(".card_product_sku_" + $(this).val()).val();
            if (prodMaxqut != "") {
                var maxQuant = checkMaxquantity(prodId);
                if (maxQuant != "") {
                    var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
                } else {
                    var max_total_quantity = parseInt(prodQuant);
                }

                if (max_total_quantity > prodMaxqut) {
                    quncheck.push(1);
                    prodTitle.push(prodtitle);
                }
            }
            var taxtags_fb = $("#tags_" + $(this).val()).val();
            var addtaxfree = taxtags_fb.indexOf('taxfree') != -1;
            if (addtaxfree == true) {
                tax_total_quantity++
            }
            var isCTOSku = !!$CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden') && isMainProduct;

            // check if has GWP and on a CTO PDP and add the correct properties to each
            let gwpSku = '';
            let gwpHandle = '';
            let gwpMainProductSku = '';
            let gwpMainProductHandle = '';
            if (isCTOSku) {
              var prodGWPSkus = $("#card_product_gwp_skus_" + $(this).val()).val();
              $.each($("input[name='frequent-products-pdp']:checked"), function() {
                var prodGwpSku = $(".card_product_sku_" + $(this).val()).val();
                var prodGwpHandle = $("#card_product_handle_" + $(this).val()).val();
                if (prodGwpSku && prodGWPSkus?.includes(prodGwpSku)) {
                  var skucomma = gwpSku === '' ? '' : ',';
                  var handledash = gwpHandle === '' ? '' : '-';
                  gwpSku = `${gwpSku}${skucomma}${prodGwpSku}`;
                  gwpHandle = `${gwpHandle}${handledash}${prodGwpHandle}`;
                  prod_handle = `${prod_handle}-${prodGwpHandle}`;
                }
              });
            } else {
              var ctoMainProduct = $("input.js-is-main-product[name='frequent-products-pdp']:checked");
              var hasCtoMain = !!$CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden') && ctoMainProduct.length;
              if (hasCtoMain) {
                var prodGWPSkus = $("#card_product_gwp_skus_" + $(ctoMainProduct).val()).val();
                if (prodGWPSkus?.includes(prodSku)) {
                  gwpMainProductSku = $(".card_product_sku_" + $(ctoMainProduct).val()).val();
                  gwpMainProductHandle = $("#card_product_handle_" + $(ctoMainProduct).val()).val();
                  prod_handle = gwpMainProductHandle;
                  $.each($("input[name='frequent-products-pdp']:checked:not(.js-is-main-product)"), function() {
                    var prodGwpSku = $(".card_product_sku_" + $(this).val()).val();
                    var prodGwpHandle = $("#card_product_handle_" + $(this).val()).val();
                    if (prodGwpSku && prodGWPSkus?.includes(prodGwpSku)) {
                      prod_handle = `${prod_handle}-${prodGwpHandle}`;
                    }
                  });
                }
              }
            }
            item = {}
            item["quantity"] = 'quantity:1';
            item["id"] = $(this).val();
            item["properties"] = {
                _uuid: prod_handle,
                ...(prodPreorder === 'true' && { _preOrder: 'true' }),
                ...(prodPreorderMessage && { _preOrderMessage: prodPreorderMessage }),
                ...(prodTradeIn === 'true' && { _tradeInEligible: 'true' }),
                ...(isCTOSku && { _cto_product: 'true' }),
                ...(gwpSku !== '' && { _gwp_sku: gwpSku }),
                ...(gwpHandle !== '' && { _gwp_handle: gwpHandle }),
                ...(gwpMainProductSku !== '' && { _gwp_main_product_sku: gwpMainProductSku }),
                ...(gwpMainProductHandle !== '' && { _gwp_main_product_handle: gwpMainProductHandle }),
            }
            frequentProducts.push(item);
            var prodType = $(".card_product_category_" + $(this).val()).val();

            var prodPrice = $(".card_product_price_" + $(this).val()).attr("value");
            var prodSku = $(".card_product_sku_" + $(this).val()).attr("value");
            var compareprice = $(".card_product_compare_" + $(this).val()).attr("value");
            var productList = $(".button-cart-frequent").attr("product-list");
            var mpn_handle = $("#mpn_handle").val();
            var shopify_rec = "Shopify Rec :: " + mpn_handle;
            prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g, ""));
            value_price += parseFloat(prodPrice);
            value_price = parseFloat(value_price);
            var productPrice1 = parseFloat(prodPrice);
            item_ga = {}
            item_ga["item_id"] = prodSku;
            item_ga["item_name"] = prodtitle;
            item_ga["item_category"] = prodType;
            item_ga["item_list_name"] = shopify_rec;
            item_ga["price"] = parseFloat(productPrice1);
            item_ga["quantity"] = 1;
            frequentProducts_ga.push(item_ga);


        });

        if (jQuery.inArray(1, quncheck) !== -1) {
            var prod_title = prodTitle.join();
            alert(quantity_limit_error_message + " " + prod_title);
            $('.button-cart-frequent').attr('aria-disabled', false);
            $('.button-cart-frequent').removeClass('loading');
            $('.loading-overlay__spinner-frequent').addClass('hidden');
            return false;
        }
        /* VAT Product Limits - Karthikeyan */
        if (vat_free_day == true) {
            if (getCookie('total_quantity') == "") {
                var tax_total_quantity = parseInt(tax_total_quantity);
            } else {
                var tax_total_quantity = parseInt(tax_total_quantity) + parseInt(getCookie('total_quantity'));
            }
            if (tax_total_quantity > vat_free_quantity) {
                alert(vat_free_message);
                $('.button-cart-frequent').attr('aria-disabled', false);
                $('.button-cart-frequent').removeClass('loading');
                $('.loading-overlay__spinner-frequent').addClass('hidden');
                return false;
            }
        }

        const adobeItems = frequentProducts.map(item => {
          return {
            ...item,
            quantity: item.quantity?.replace('quantity:', '') || 1,
          }
        });

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "post",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    items: frequentProducts
                }),
            }).then(response => {
                 return response.json().then(d => {
                  if (d.status === 422) {
                    console.error('Error:', d.message);
                    $('.button-cart-frequent').attr('aria-disabled', false);
                    $('.button-cart-frequent').removeClass('loading');
                    $('.loading-overlay__spinner-frequent').addClass('hidden');
                    return false;
                  }
                   // cart drawer UX open & update
                   const wdCartDrawer = document.querySelector('cart-drawer');
                   if (wdCartDrawer) {
                     wdCartDrawer.updateItems();
                   }
                   var mpn_handle = $("#mpn_handle").val();
                   var shopify_rec = "Shopify Rec :: " + mpn_handle;
                    var exphone_fa = [];
                   if (JSON.parse(localStorage.getItem("cart")) != null) {
                            exphone_fa = JSON.parse(localStorage.getItem("cart"));
                    }
                    for (var i = 0; i < d.items.length; i++) {
                        item_cart_fa = {}
                        item_cart_fa["cart_item_id"] = d.items[i].key;
                        item_cart_fa["cart_item_list_name"] = shopify_rec;
                        item_cart_fa["cart_item_mpn"] = d.items[i].sku;
                        exphone_fa.push(item_cart_fa);
                    }
                   // console.log("1");
                   // console.log(exphone_fa);
                   localStorage.setItem("cart", JSON.stringify(exphone_fa));

                  if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
                    $CTOcartDrawer[0].forceClearCtoItems();
                    $CTOcartDrawer[0].updateItems(d.items);
                  }

                  //WD SPECIFIC bug fix - START
                  if (typeof adobeTrackAddToCart === 'function') {
                    adobeTrackAddToCart({
                      items: adobeItems,
                      context: 'Frequently Bought Together',
                      $trigger: $('#card-button')[0],
                    });
                  }
                  //WD SPECIFIC bug fix - END
                  // checkQuantity();
                  $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
                      var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
                      if ($('.cart-count-bubble').length > 0) {
                          $('.cart-count-bubble span').text(item_count);
                      } else {
                          $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
                          $('.cart-count-bubble span').text(item_count);
                      }
                      $("#cart-notification").text("");
                      var textreplace = "<div id='min-cart-replace'></div>";
                      $("#cart-notification").append(textreplace);
                      $("#cart-notification").replaceWith(itemData);
                      if (!$CTOcartDrawer.length || $CTOcartDrawer.hasClass('hidden')) {
                        $('#cart-notification').addClass('minicart-active');
                      }
                  });
                  dataLayer.push({
                      'ecommerce': null
                  });
                  dataLayer.push({
                      'event': 'add_to_cart',
                      'ecommerce': {
                          'value': value_price,
                          'currency': prodCurrency,
                          'items': frequentProducts_ga
                      }
                  });

                  $('.button-cart-frequent').attr('aria-disabled', false);
                  $('.button-cart-frequent').removeClass('loading');
                  $('.loading-overlay__spinner-frequent').addClass('hidden');
                  if (window.location.href.indexOf("/cart") > -1) {
                      window.onCartUpdate();
                  }
                }).catch((jsonError) => {
                  //WD SPECIFIC bug fix - START
                    console.error('JSON parsing error:', jsonError);
                    $('.button-cart-frequent').attr('aria-disabled', false);
                    $('.button-cart-frequent').removeClass('loading');
                    $('.loading-overlay__spinner-frequent').addClass('hidden');
                    //WD SPECIFIC bug fix - END
                    return false;
                });
            })
            .catch((error) => {
                console.error('Error:', error);
                //WD SPECIFIC bug fix - START
                $('.button-cart-frequent').attr('aria-disabled', false);
                $('.button-cart-frequent').removeClass('loading');
                $('.loading-overlay__spinner-frequent').addClass('hidden');
                //WD SPECIFIC bug fix - END
                return false;
            });
        return false;
    });
    /* Ends Frequently add Products Karthikeyan */

    function quickAddEvents() {
      var quickAddButtons = $('.slider-form:not(.event-attached)');
      quickAddButtons.click(async function (evt) {
        evt.preventDefault();
        // set all btn disabled
        document.querySelectorAll(".wd-fast-atc-button").forEach(button => {
          button.setAttribute("disabled", true);
          if(button == evt.target || button.contains(evt.target))
            button.setAttribute("loading", true);
        });
        try {
          var $CTOcartDrawer = $('cto-cart-drawer');
          var mpn_handle = $("#mpn_handle").val();
          /* Order Product Limits - Karthikeyan */
          var pageName = window.location.href;
          var prodId = $(this).attr("data-productid");
          var prodQuant = 1;
          var prodMaxqut = $(this).attr("data-productmaxquantity");
          var cartpage = $(this).attr("data-cartpage");
          if (cartpage == "Cart Page") {
            var attach = "ATTACH :: Cart Page";
          } else {
            var attach = "ATTACH :: ";
          }
          if (prodMaxqut != "") {
            var maxQuant = checkMaxquantity(prodId);
            if (maxQuant != "") {
              var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
            } else {
              var max_total_quantity = parseInt(prodQuant);
            }
            if (max_total_quantity > prodMaxqut) {
              alert(quantity_limit_error_message);
              return false;
            }
          }
          var slider_variantid = $(this).attr("data-variantid");
          var slider_tag = $(this).attr("data-tag");
          //souvik code for product list tracking starts
          var collection_name = $(this).attr("data-collection");
          var main_product_sku = $(this).attr("data-productsku");
          if (pageName.includes("products")) {
            var mpn_handle = $("#mpn_handle").val();
            var productList = mpn_handle;
          } else if (pageName.includes("search")) {
            var productList = 'Search Results';
          } else {
            var productList = formatString($(this).attr("data-productlist"));
          }
          var productCategory = $(this).attr("data-producttype");
          var productPrice = $(this).attr("data-productprice");
          var productcomPrice = $(this).attr("data-productcompprice");
          var productCurrency = $(this).attr("data-productcurrency");
          var productTitle = $(this).attr("data-producttitle");
          var productMPN = $(this).attr("data-productMPN");
          var productHandle = $(this).attr("data-producthandle");
          var productPreOrder = $(this).attr("data-productpreorder");
          var productPreOrderMessage = $(this).attr("data-productpreordermessage");
          var productTradeIn = $(this).attr("data-producttradein");
          var gwpData = $(this).find('.js-slider-form-gwp-data');
          var gwpMaximum = $(this).find('.js-slider-form-gwp-data').data('gwp-maximum');
          var hasGwp = gwpData.length > 0;
          //souvik code for product list trackingends

          /* VAT Product Limits - Karthikeyan */
          if (vat_free_day == true) {
            var addtaxfree = slider_tag.indexOf('taxfree') != -1;
            if (addtaxfree == true) {
              if (getCookie('total_quantity') >= vat_free_quantity) {
                alert(vat_free_message);
                return false;
              }
            }
          }
          $('#slider-form-' + slider_variantid).attr('aria-disabled', true);
          $('#slider-form-' + slider_variantid).addClass('loading');
          $('.loading-overlay__spinner-frequent').removeClass('hidden');

          var uid = productHandle;
          var gwpKey = btoa(Math.random());

          if (hasGwp) {
            uid = uid + '-' + gwpKey;
          }

          const props = {
            _uuid: uid,
            ...(productPreOrder === 'true' && { _preOrder: 'true' }),
            ...(productPreOrderMessage && { _preOrderMessage: productPreOrderMessage }),
            ...(productTradeIn === 'true' && { _tradeInEligible: 'true' }),
          }; 

          if (hasGwp) {
            var gwpSkus = [];
            var gwpHandles = [];
            gwpData.each(function () {
              gwpSkus.push($(this).data('gwp-product-sku'));
              gwpHandles.push($(this).data('gwp-product-handle'));
            });
            props._gwp_sku = gwpSkus.join(',');
            props._gwp_handle = gwpHandles.join('-');
          }

          var items = [{
            id: slider_variantid,
            quantity: 1,
            properties: props,
          }];

          if (hasGwp) {
            gwpData.each(function () {
              items.push({
                id: $(this).data('gwp-id'),
                quantity: Math.min($(this).data('gwp-quantity'), gwpMaximum || 0),
                properties: {
                  _gwp_main_product_sku: main_product_sku,
                  _gwp_main_product_handle: productHandle,
                  _uuid: uid
                }
              });
            });
          }

          const adobeItems = [];
          items.forEach(item => {
            adobeItems.push({
              id: item.id,
              quantity: item.quantity,
            });
          });

          await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "post",
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({ items }),
          }).then(response => {

            response.json().then(d => {
              if (d.status === 422) {
                console.error('Error:', d.message);
                return false;
              }

              // Match PDP addToCart: open drawer + reload cart markup inside it
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                cartDrawer.updateItems();
              }

              if (d?.items?.length) {
                cartCookie(productMPN, d.items[0].key, prod_list);
              }

              if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
                $CTOcartDrawer[0].updateItems(d.items);
              }
            })

            //checkQuantity();
            if (cartpage == "Cart Page") {
              var prod_list = attach;
            } else if (pageName.includes("search")) {
              var prod_list = productList;
            } else {
              var prod_list = attach + productList;
            }

            removeGwpData(gwpData);

            //souvik code for product list tracking starts
            triggerGAAddToCart(productcomPrice, main_product_sku, productTitle, productCategory, prod_list, productCurrency, productPrice, prodQuant, main_product_sku, slider_variantid);
            //souvik code for product list tracking ends

            if (typeof adobeTrackAddToCart === 'function')
              adobeTrackAddToCart({
                items: adobeItems,
                context: 'Quick Add',
                $trigger: this,
              });

            if (cartpage == "Cart Page") {
              window.onCartUpdate({ scrollToTop: true });
              return false;
            }
            $.get(`${window.Shopify.routes.root}cart?view=minicart`, function (itemData) {
              var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
              if ($('.cart-count-bubble').length > 0) {
                $('.cart-count-bubble span').text(item_count);
              } else {
                $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
                $('.cart-count-bubble span').text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              if (!$CTOcartDrawer.length || $CTOcartDrawer.hasClass('hidden')) {
                $('#cart-notification').addClass('minicart-active');
              }
            });
            $('#slider-form-' + slider_variantid).attr('aria-disabled', false);
            $('#slider-form-' + slider_variantid).removeClass('loading');
            $('.loading-overlay__spinner-frequent').addClass('hidden');
          })
            .catch((error) => {
              console.error('Error:', error);
              return false;
            });
          return false;
        } catch (_) { }
        finally {
          // enable all btn
          document.querySelectorAll(".wd-fast-atc-button").forEach(button => {
            button.setAttribute("disabled", false);
            button.setAttribute("loading", false);
          });
        }
      });
      quickAddButtons.addClass('event-attached');

    }

    quickAddEvents();
    window.quickAddEvents = quickAddEvents;
    // Wedev: expose the GA add-to-cart helpers for adds outside this file (cart drawer recommendations)
    window.wdCartCookie = cartCookie;
    window.wdTriggerGAAddToCart = triggerGAAddToCart;

    /*Add Applecare on cart page functionality  starts here - added by Hema*/
    $(document).on('click', '.add-cart-apple-care', async function(e) {
        e.preventDefault();
        var $CTOcartDrawer = $('cto-cart-drawer');
        $(this).prop('disabled', true);
        this.setAttribute('loading', 'true');

        if (window.toggleAddOnButtons) window.toggleAddOnButtons('disable');
        var add_button = $(this);
        var product_id = add_button.data('variantid');
        var main_product_index = add_button.data('forproduct');
        var wp_idx = add_button.data('forwproduct');
        var wp_key = add_button.data('forwkey');
        var wp_idx2 = add_button.data('forwproduct2');
        var wp_key2 = add_button.data('forwkey2');
        var wp_idx_gwp = add_button.data('forwproductgwp');
        var wp_key_gwp = add_button.data('forwkeygwp');
        var previous_uid = add_button.data('uuid');
        var main_product_parent = $('#CartItem-' + main_product_index);
        var has_applcr_sku = main_product_parent.data('applecare_sku')?.trim();
        var has_applcr_handle = main_product_parent.data('applecare_handle');
        var has_sw_sku = main_product_parent.data('secwarranty_sku')?.trim();
        var has_sw_handle = main_product_parent.data('secwarranty_handle');
        var has_gwp_sku = main_product_parent.data('gwp_sku')?.trim();
        var has_gwp_handle = main_product_parent.data('gwp_handle');
        var isCTO = main_product_parent.data('cto-product');
        var main_product_quantity = main_product_parent.find('.quantity__input')?.val();
        var main_product_sku = add_button.data('skuparent');
        var main_product_handle = add_button.data('handleparent');
        var main_product_preorder = add_button.data('preorderparent');
        var main_product_preorder_message = add_button.data('preordermessageparent');
        var main_product_trade_in = add_button.data('tradeinparent');
        var main_product_key = add_button.data('keyparent');
        var aplCr_sku = add_button.data('skuaplcr');
        var applecarempn = add_button.data('mpnaplcr');
        var aplCr_handle = add_button.data('handleaplcr');
        var main_mpn_value = add_button.data('mpnparent');
        var additional_flag = add_button.data('reference')
        var gwp_maximum_reached = add_button.data('gwp-maximum-reached');
        var gwp_maximum = add_button.data('gwp-maximum');
        var main_product_tags = main_product_parent.find('.cart_tax_tags')?.val();
        var override_quantity = add_button.data('overridequantity');
        const tradeInValue = $(main_product_parent).data('tradeInValue');
        const tradeInDevice = $(main_product_parent).data('tradeInDevice');
        const tradeInSetNumber = $(main_product_parent).data('tradeInSetNumber');
        if (additional_flag === 'gwp' && gwp_maximum_reached) {
          alert(gwp_quantity_limit_error_message.replace('{limit}', gwp_maximum));
          $(this).prop('disabled', false);
          this.setAttribute('loading', 'false');
          if (window.toggleAddOnButtons) window.toggleAddOnButtons('enable');
          return;
        }

        let add_gwp_skus = [];
        let add_gwp_handles = [];
        $(`.add-cart-apple-care[data-reference="gwp"][data-skuaplcr="${aplCr_sku}"][data-handleaplcr="${aplCr_handle}"], .gwp_dpnd_${main_product_index}`).each(function() {
          let gwp_sku;
          let gwp_handle;
          if ($(this).hasClass('add-cart-apple-care')) {
            gwp_sku = $(this).data('skuaplcr');
            gwp_handle = $(this).data('handleaplcr');
          } else {
            gwp_sku = $(this).find('cart-remove-button').data('gwp-sku');
            gwp_handle = $(this).find('cart-remove-button').data('gwp-handle');
          }

          if (!add_gwp_handles.includes(gwp_handle)) {
            add_gwp_skus.push(gwp_sku);
            add_gwp_handles.push(gwp_handle);
          }
        });
        //wd adding set number to group product and insurances logic starts here
        // Get the existing setNumber from the main product item in the cart
        // This ensures we use the same setNumber that already exists for this specific product
        // Only generate a new setNumber if one doesn't exist (shouldn't happen for items with insurance)
        // Fetch cart to get the actual setNumber and properties from the cart item
        // This ensures we preserve the existing setNumber and don't accidentally overwrite other properties
        var cartData = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json());
        var mainProductCartItem = cartData.items.find(item => item.key === main_product_key || (item.line === main_product_index));
        var existingSetNumber = mainProductCartItem?.properties?._set_number || null;
        var existingBundleSetNumber = mainProductCartItem?.properties?._bundle_set_number || null;
        // Use existing setNumber if it exists, otherwise generate a new one
        // This is critical: we must preserve the setNumber for items that already have insurance
        const setNumber = existingSetNumber || Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
        
        // Build update data for main product
        // Note: cart/change.js API replaces properties, so we must re-include all props to keep
        // The setNumber is critical - we preserve the existing one if it exists
        var data = {
          line: main_product_index,
          quantity: main_product_quantity,
          properties: {
            _set_number: setNumber,  // Preserve existing setNumber or use the one we just got
          },
        };

        if (existingBundleSetNumber) {
          data.properties._bundle_set_number = existingBundleSetNumber;
        }

        if (main_product_preorder) {
          data.properties._preOrder = 'true';
        }

        if (main_product_preorder_message) {
          data.properties._preOrderMessage = main_product_preorder_message;
        }

        // Wedev: launch period lines carry _launchPeriod* (the PDP prerelease property) instead of _preOrder* - keep them, change.js replaces all properties
        Object.entries(mainProductCartItem?.properties || {}).forEach(([key, value]) => {
          if (key.startsWith('_launchPeriod')) data.properties[key] = value;
        });

        if (main_product_trade_in) {
          data.properties._tradeInEligible = 'true';
        }

        if (isCTO) {
          data.properties._cto_product = 'true';
        }

        // if (tradeInValue) {
        //   data.properties._tradeIn_value = tradeInValue.toString().replace('.', '');
        // }
        if (tradeInSetNumber) {
          data.properties._trade_in_set_number = tradeInSetNumber;
        }
        // if (tradeInDevice) {
        //   data.properties._tradeIn_device = tradeInDevice;
        // }

        var uid = main_product_handle;

        // One warranty per product: when adding one warranty, clear the other from main product props
        if (additional_flag == "aplcr") {
          uid = uid + '-' + aplCr_handle;
          data.properties._applecare_sku = aplCr_sku;
          data.properties._applecare_handle = aplCr_handle;
          data.properties._set_number = setNumber;
          data.properties._secWarranty_sku = '';
          data.properties._secWarranty_handle = '';
        } else if (has_applcr_sku) {
          uid = uid + '-' + has_applcr_handle;
          data.properties._applecare_sku = has_applcr_sku;
          data.properties._applecare_handle = has_applcr_handle;
          data.properties._set_number = setNumber;
        }

        if (additional_flag == "secwr") {
          uid = uid + '-' + aplCr_handle;
          data.properties._secWarranty_sku = aplCr_sku;
          data.properties._secWarranty_handle = aplCr_handle;
          data.properties._set_number = setNumber;
          data.properties._applecare_sku = '';
          data.properties._applecare_handle = '';
        } else if (has_sw_sku) {
          uid = uid + '-' + has_sw_handle;
          data.properties._secWarranty_sku = has_sw_sku;
          data.properties._secWarranty_handle = has_sw_handle;
          data.properties._set_number = setNumber;
        }

        var gwpKey = btoa(Math.random());
        if (additional_flag == "gwp") {
          uid = uid + '-' + gwpKey;
          data.properties._gwp_sku = add_gwp_skus.join(',');
          data.properties._gwp_handle = add_gwp_handles.join('-');
        } else if (has_gwp_sku) {
          uid = uid + '-' + gwpKey;
          data.properties._gwp_sku = has_gwp_sku;
          data.properties._gwp_handle = has_gwp_handle;
        }

        data.properties._uuid = uid;

        data = JSON.stringify(data);

        if (!has_applcr_sku && !has_sw_sku && !has_gwp_sku) {
          var wp_idx = 0;
          var wp_idx2 = 0;
        }

        var oldData = JSON.parse(data);
        // Split into individual items when quantity > 1 AND (insurance is being added OR GWP)
        // Each pair (product + insurance) gets its own setNumber for order sync app
        const isAddingInsurance = additional_flag == "aplcr" || additional_flag == "secwr";
        var shouldSplitIntoIndividualItems = parseInt(oldData.quantity) > 1 && (isAddingInsurance || additional_flag == "gwp");
        if (shouldSplitIntoIndividualItems) {
          // if quantity is more than 1, we need to break up the line items to each individual item
          // For insurance: each pair/triplet (product + insurance/insurances) gets its own setNumber
          // UUID remains the same for all items in a pair/triplet (old logic)
          // For GWP: each item gets its own GWP with unique UUID
          var splitQty = parseInt(oldData.quantity);
          var newSetNumbers = Array.from(Array(splitQty)).map(() => {
            return Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
          });
          // Insurance + bundle: each unit needs its own bundle set (1:1). GWP keeps first-unit-only link.
          var newBundleSetNumbers = (isAddingInsurance && existingBundleSetNumber)
            ? Array.from(Array(splitQty)).map(() => Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10))
            : null;
          // Capture bundle children before parent delete so we can re-add them per unit
          var bundleChildrenToSplit = [];
          if (newBundleSetNumbers) {
            cartData.items.forEach(function (item) {
              if (item.properties?._isBundleProduct === 'true' && String(item.properties._bundle_set_number) === String(existingBundleSetNumber)) {
                bundleChildrenToSplit.push({
                  id: item.variant_id,
                  perUnit: Math.max(1, Math.floor(item.quantity / splitQty)),
                });
              }
            });
          }
          var newLineItemsDataProperties = Array.from(Array(splitQty)).map((_, index) => {
            var newUuid;
            if (isAddingInsurance) {
              // For insurance, keep the same UUID for all items in pair/triplet (old logic)
              // Build UUID based on main product handle + insurance handle(s)
              var baseUid = main_product_handle;
              if (additional_flag == "aplcr") {
                baseUid = baseUid + '-' + aplCr_handle;
              } else if (additional_flag == "secwr") {
                baseUid = baseUid + '-' + aplCr_handle;
              }
              // If there's already insurance, include it in UUID
              if (has_applcr_sku && additional_flag != "aplcr") {
                baseUid = baseUid + '-' + has_applcr_handle;
              }
              if (has_sw_sku && additional_flag != "secwr") {
                baseUid = baseUid + '-' + has_sw_handle;
              }
              newUuid = baseUid;
            } else {
              // For GWP, use existing logic with unique UUIDs
              newUuid = oldData.properties._uuid.replace(`-${gwpKey}`, `-${btoa(Math.random())}`);
              if (gwp_maximum && index >= gwp_maximum) {
                newUuid = oldData.properties._uuid.replace(`-${gwpKey}`, '');
              }
            }
            var newProps = {
              ...oldData.properties,
              _uuid: newUuid, // Same UUID for all items in pair/triplet
            };
            // Update setNumber for insurance (unique per pair/triplet)
            if (isAddingInsurance) {
              newProps._set_number = newSetNumbers[index];
            }
            if (newBundleSetNumbers) {
              newProps._bundle_set_number = newBundleSetNumbers[index];
            } else if (existingBundleSetNumber && index === 0) {
              // GWP split: keep bundle link only on the first unit (same pattern as trade-in)
              newProps._bundle_set_number = existingBundleSetNumber;
            } else {
              delete newProps._bundle_set_number;
            }
            return newProps;
          });
          const originalLineItemData = JSON.stringify({...oldData, quantity: 0});
          var data = await $.ajax({
            url: `${window.Shopify.routes.root}cart/change.js`,
            type: "POST",
            data: originalLineItemData,
            contentType: "application/json",
            dataType: 'json',
          });

          var allCartItemsBeforeDeletion = data.items;
          const variantId = data.items_removed[0].variant_id;
          // Parent delete leaves bundle children on the old set — remove them before re-adding 1:1
          if (bundleChildrenToSplit.length && existingBundleSetNumber) {
            var bundleUpdates = {};
            data.items.forEach(function (item) {
              if (item.properties?._isBundleProduct === 'true' && String(item.properties._bundle_set_number) === String(existingBundleSetNumber)) {
                bundleUpdates[item.key] = 0;
              }
            });
            if (Object.keys(bundleUpdates).length) {
              data = await $.ajax({
                url: `${window.Shopify.routes.root}cart/update.js`,
                type: "POST",
                data: { updates: bundleUpdates },
                dataType: 'json',
              });
            }
          }
          // Main-only list — later care/GWP split logic indexes this by unit, not bundle children
          var newItemsToAdd = newLineItemsDataProperties.map((properties) => {
            return {
              id: variantId,
              quantity: 1,
              properties,
            };
          });
          var itemsPayloadToAdd = newItemsToAdd.slice();
          // Re-add one bundle child group per split main (matching that unit's bundle set)
          if (newBundleSetNumbers && bundleChildrenToSplit.length) {
            newBundleSetNumbers.forEach(function (bundleSet) {
              bundleChildrenToSplit.forEach(function (child) {
                itemsPayloadToAdd.push({
                  id: child.id,
                  quantity: child.perUnit,
                  properties: {
                    _isBundleProduct: 'true',
                    _bundle_set_number: bundleSet,
                  },
                });
              });
            });
          }
          var data = await $.ajax({
            url: `${window.Shopify.routes.root}cart/add.js`,
            type: "POST",
            data: JSON.stringify({items: itemsPayloadToAdd}),
            contentType: "application/json",
            dataType: 'json',
          });
          if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
            $CTOcartDrawer[0].updateCurrentItemsAll(data.items);
          }

          // AppleCare can get removed when we delete the parent product. This variable keeps track of them
          var cartItemsRemovedAfterDeletion = allCartItemsBeforeDeletion.filter((item) => !data.items.find((newItem) => newItem.key === item.key));
        } else {
          var data = await $.ajax({
            url: `${window.Shopify.routes.root}cart/change.js`,
            type: "POST",
            data: data,
            contentType: "application/json",
            dataType: 'json',
          });
        }

        if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
          var newCTOItem = data.items?.find((item) => item.properties?._cto_product);
          var newCTOItemKey = newCTOItem?.key;
          var newCTOItemUuid = newCTOItem?.properties?._uuid;
          $CTOcartDrawer[0].updateCtoItemKey(newCTOItemKey);
        }

        // Track which care products have already been updated to prevent duplicate updates
        // This is important when multiple care products exist (e.g., AppleCare + Secondary Warranty)
        var checked = {};
        
        // ============================================================================
        // UPDATE FIRST EXISTING CARE PRODUCT (wp_key)
        // ============================================================================
        // wp_key represents the first care product that was already in the cart
        // This could be AppleCare or Secondary Warranty
        // When a new care product is added, we need to update existing ones to match the new UUID
        if (wp_key) {
          // Check if AppleCare already exists and hasn't been updated yet
          if (has_applcr_sku && !checked[has_applcr_sku]) {
            // Use wp_key directly since it's the unique cart item key passed from the cart
            // This is more reliable than searching by SKU + UUID which can match multiple items
            // First verify the item exists and matches our expectations
            var existingItem = data.items.find(item => item.key === wp_key);
            
            // Verify it's the correct item (safety check)
            // Must match: SKU, UUID, AND setNumber to ensure we're updating the right item
            if (existingItem && existingItem.properties?._aplcr_main_product_sku === main_product_sku && existingItem.properties?._uuid === previous_uid && existingItem.properties?._set_number === setNumber) {
              var newWpKey = wp_key;
            } else {
              // Fallback: if wp_key doesn't match, search by SKU + UUID + setNumber
              // This ensures we only update the AppleCare item that matches this specific product's setNumber
              var newWpKey = data.items.find(item => item.properties?._aplcr_main_product_sku === main_product_sku && item.properties?._uuid === previous_uid && item.properties?._set_number === setNumber)?.key || wp_key;
            }
            
            var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
            var newWpVariantId = data.items.find(item => item.key === newWpKey)?.variant_id;
            
            // Build update payload for AppleCare item
            // Update UUID to match new UUID (which now includes the newly added care product)
            // Update setNumber to match the new setNumber
            var data2 = {
              line: newWpLine,
              quantity: main_product_quantity,
              properties: {
                _aplcr_main_product_sku: main_product_sku,
                _aplcr_main_product_handle: main_product_handle,
                _set_number: setNumber,
                _uuid: uid,  // Updated UUID to match new bundle
              },
            };
            data2 = JSON.stringify(data2);
            checked[has_applcr_sku] = true;  // Mark as updated to prevent duplicate processing
            
          } else if (has_sw_sku && !checked[has_sw_sku]) {
            // Use wp_key directly since it's the unique cart item key passed from the cart
            // This is more reliable than searching by SKU + UUID which can match multiple items
            var existingItem = data.items.find(item => item.key === wp_key);
            
            // Verify it's the correct item (safety check)
            // Must match: SKU, UUID, AND setNumber to ensure we're updating the right item
            if (existingItem && existingItem.properties?._sw_main_product_sku === main_product_sku && existingItem.properties?._uuid === previous_uid && existingItem.properties?._set_number === setNumber) {
              var newWpKey = wp_key;
            } else {
              // Fallback: if wp_key doesn't match, search by SKU + UUID + setNumber
              // This ensures we only update the Secondary Warranty item that matches this specific product's setNumber
              var newWpKey = data.items.find(item => 
                item.properties?._sw_main_product_sku === main_product_sku && 
                item.properties?._uuid === previous_uid &&
                item.properties?._set_number === setNumber
              )?.key || wp_key;
            }
            
            var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
            var data2 = {
              line: newWpLine,
              quantity: main_product_quantity,
              properties: {
                _sw_main_product_sku: main_product_sku,
                _sw_main_product_handle: main_product_handle,
                _set_number: setNumber,
                _uuid: uid,  // Updated UUID to match new bundle
              },
            };
            data2 = JSON.stringify(data2);
            checked[has_sw_sku] = true;  // Mark as updated
          }

          // ========================================================================
          // HANDLE QUANTITY SPLITTING FOR EXISTING CARE PRODUCT
          // ========================================================================
          // If the main product was split (quantity > 1), we need to split the existing
          // care product to match. Each care product item should match its corresponding
          // main product item's UUID and setNumber.
          if (shouldSplitIntoIndividualItems) {
            var oldData = JSON.parse(data2);
            
            // Create properties for each individual care product item
            // Each item's UUID matches its corresponding main product item's UUID
            // This ensures proper pairing when items are split
            var newLineItemsDataProperties = Array.from(Array(parseInt(newItemsToAdd.length))).map((_, index) => {
              return {
                ...oldData.properties,
                _uuid: newItemsToAdd[index].properties._uuid,  // Match corresponding main product UUID
              };
            });

            // Step 1: Delete the original care product line item (set quantity to 0)
            const originalLineItemData = JSON.stringify({...oldData, quantity: 0});
            var data = await $.ajax({
              url: `${window.Shopify.routes.root}cart/change.js`,
              type: "POST",
              data: originalLineItemData,
              contentType: "application/json",
              dataType: 'json',
            });

            // Step 2: Get the variant ID from the deleted item
            // This is needed to re-add the items with the same variant
            const variantId = cartItemsRemovedAfterDeletion.find(item => item.properties?._aplcr_main_product_sku)?.variant_id;
            
            // Step 3: Create individual care product items (quantity = 1 each)
            // Each item matches its corresponding main product item
            var newItemsToAdd = newLineItemsDataProperties.map((properties) => {
              return {
                id: variantId,
                quantity: 1,  // Each item is quantity 1
                properties,
              };
            });
            
            // Step 4: Re-add the split care product items to cart
            var data = await $.ajax({
              url: `${window.Shopify.routes.root}cart/add.js`,
              type: "POST",
              data: JSON.stringify({items: newItemsToAdd}),
              contentType: "application/json",
              dataType: 'json',
            });
            
            // Update CTO cart drawer if it exists
            if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
              $CTOcartDrawer[0].updateCurrentItemsAll(data.items);
            }
          } else {
            // If no splitting needed (quantity = 1), simply update the existing care product
            // with the new UUID and setNumber
            var data = await $.ajax({
              url: `${window.Shopify.routes.root}cart/change.js`,
              type: "POST",
              data: data2,
              contentType: "application/json",
              dataType: 'json',
            });
          }
        }

        // ============================================================================
        // UPDATE SECOND EXISTING CARE PRODUCT (wp_key2)
        // ============================================================================
        // wp_key2 represents a second care product (e.g., if both AppleCare and Secondary
        // Warranty exist, wp_key might be AppleCare and wp_key2 might be Secondary Warranty)
        // Same logic as wp_key but for the second care product
        if (wp_key2) {
          // Check if AppleCare exists and hasn't been updated yet (might be the second one)
          if (has_applcr_sku && !checked[has_applcr_sku]) {
            // Use wp_key2 directly since it's the unique cart item key passed from the cart
            // This is more reliable than searching by SKU + UUID which can match multiple items
            var existingItem = data.items.find(item => item.key === wp_key2);
            
            // Verify it's the correct item (safety check)
            // Must match: SKU, UUID, AND setNumber to ensure we're updating the right item
            if (existingItem && existingItem.properties?._aplcr_main_product_sku === main_product_sku && existingItem.properties?._uuid === previous_uid && existingItem.properties?._set_number === setNumber) {
              var newWpKey = wp_key2;
            } else {
              // Fallback: if wp_key2 doesn't match, search by SKU + UUID + setNumber
              // This ensures we only update the AppleCare item that matches this specific product's setNumber
              var newWpKey = data.items.find(item => 
                item.properties?._aplcr_main_product_sku === main_product_sku && 
                item.properties?._uuid === previous_uid &&
                item.properties?._set_number === setNumber
              )?.key || wp_key2;
            }
            
            var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
            var data2 = {
              line: newWpLine,
              quantity: main_product_quantity,
              properties: {
                _aplcr_main_product_sku: main_product_sku,
                _aplcr_main_product_handle: main_product_handle,
                _uuid: uid,
              },
            };
            data2 = JSON.stringify(data2);
            checked[has_applcr_sku] = true;
          } else if (has_sw_sku && !checked[has_sw_sku]) {
            // Update Secondary Warranty if it's the second care product
            // Use wp_key2 directly since it's the unique cart item key passed from the cart
            // This is more reliable than searching by SKU + UUID which can match multiple items
            var existingItem = data.items.find(item => item.key === wp_key2);
            
            // Verify it's the correct item (safety check)
            // Must match: SKU, UUID, AND setNumber to ensure we're updating the right item
            if (existingItem && existingItem.properties?._sw_main_product_sku === main_product_sku && existingItem.properties?._uuid === previous_uid && existingItem.properties?._set_number === setNumber) {
              var newWpKey = wp_key2;
            } else {
              // Fallback: if wp_key2 doesn't match, search by SKU + UUID + setNumber
              // This ensures we only update the Secondary Warranty item that matches this specific product's setNumber
              var newWpKey = data.items.find(item => 
                item.properties?._sw_main_product_sku === main_product_sku && 
                item.properties?._uuid === previous_uid &&
                item.properties?._set_number === setNumber
              )?.key || wp_key2;
            }
            
            var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
            var data2 = {
              line: newWpLine,
              quantity: main_product_quantity,
              properties: {
                _sw_main_product_sku: main_product_sku,
                _sw_main_product_handle: main_product_handle,
                _uuid: uid,
              },
            };
            data2 = JSON.stringify(data2);
            checked[has_sw_sku] = true;
          }

          if (shouldSplitIntoIndividualItems) {
            var oldData = JSON.parse(data2);
            var newLineItemsDataProperties = Array.from(Array(parseInt(newItemsToAdd.length))).map((_, index) => {
              return {
                ...oldData.properties,
                _uuid: newItemsToAdd[index].properties._uuid,
              };
            });

            const originalLineItemData = JSON.stringify({...oldData, quantity: 0});
            var data = await $.ajax({
              url: `${window.Shopify.routes.root}cart/change.js`,
              type: "POST",
              data: originalLineItemData,
              contentType: "application/json",
              dataType: 'json',
            });

            const variantId = cartItemsRemovedAfterDeletion.find(item => item.properties?._sw_main_product_sku)?.variant_id;
            var newItemsToAdd = newLineItemsDataProperties.map((properties) => {
              return {
                id: variantId,
                quantity: 1,
                properties,
              };
            });
            var data = await $.ajax({
              url: `${window.Shopify.routes.root}cart/add.js`,
              type: "POST",
              data: JSON.stringify({items: newItemsToAdd}),
              contentType: "application/json",
              dataType: 'json',
            });
          } else {
            var data = await $.ajax({
              url: `${window.Shopify.routes.root}cart/change.js`,
              type: "POST",
              data: data,
              contentType: "application/json",
              dataType: 'json',
            });
          }
        }

        // One warranty per product: remove the other warranty line for this line item only (same _set_number + main product SKU)
        // So e.g. with 2 iPads each with Apple Care, switching one to second warranty only affects that iPad's warranty.
        if (isAddingInsurance && data && data.items) {
          var otherWarrantyItem = null;
          if (additional_flag === "aplcr") {
            otherWarrantyItem = data.items.find(function (i) {
              return i.properties && i.properties._set_number === setNumber &&
                i.properties._sw_main_product_sku === main_product_sku;
            });
          } else if (additional_flag === "secwr") {
            otherWarrantyItem = data.items.find(function (i) {
              return i.properties && i.properties._set_number === setNumber &&
                i.properties._aplcr_main_product_sku === main_product_sku;
            });
          }
          if (otherWarrantyItem) {
            var otherLine = data.items.findIndex(function (it) { return it.key === otherWarrantyItem.key; }) + 1;
            data = await $.ajax({
              url: `${window.Shopify.routes.root}cart/change.js`,
              type: "POST",
              data: JSON.stringify({ line: otherLine, quantity: 0 }),
              contentType: "application/json",
              dataType: 'json',
            });
          }
        }

        if (wp_key_gwp) {
          if (has_gwp_sku && !checked[has_gwp_sku]) {
            var newWpItems = data.items.filter(item => item.properties?._gwp_main_product_sku === main_product_sku && item.properties?._uuid === previous_uid);
            checked[has_gwp_sku] = true;

            for (const newWpItem of newWpItems) {
              var newWpKey = newWpItem?.key;
              var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
              var newWpQuantity = newWpItem?.quantity || 1;
              var data2 = {
                line: newWpLine,
                quantity: newWpQuantity,
                properties: {
                  _gwp_main_product_sku: main_product_sku,
                  _gwp_main_product_handle: main_product_handle,
                  _uuid: uid,
                },
              };
              data2 = JSON.stringify(data2);

              var data = await $.ajax({
                url: `${window.Shopify.routes.root}cart/change.js`,
                type: "POST",
                data: data2,
                contentType: "application/json",
                dataType: 'json',
              });
            }
          }
        }

        // Check if we need to split insurance items (when main product was split)
        var shouldSplitInsuranceItems = shouldSplitIntoIndividualItems && isAddingInsurance;
        
        var itemToAdd = {
          id: product_id,
          quantity: (override_quantity || main_product_quantity) * (additional_flag == "gwp" ? main_product_quantity : 1),
          properties: {
            _uuid: uid,
          },
        };
        if (additional_flag == "gwp" && gwp_maximum) {
          itemToAdd.quantity = Math.min(itemToAdd.quantity, gwp_maximum);
        }

        if (additional_flag == "secwr") {
          itemToAdd.properties._sw_main_product_sku = main_product_sku;
          itemToAdd.properties._sw_main_product_handle = main_product_handle;
          itemToAdd.properties._set_number = setNumber;
        } else if (additional_flag == "aplcr") {
          itemToAdd.properties._aplcr_main_product_sku = main_product_sku;
          itemToAdd.properties._aplcr_main_product_handle = main_product_handle;
          itemToAdd.properties._set_number = setNumber;
        } else if (additional_flag == "gwp") {
          itemToAdd.properties._gwp_main_product_sku = main_product_sku;
          itemToAdd.properties._gwp_main_product_handle = main_product_handle;
        }

        if (shouldSplitInsuranceItems) {
          // Split insurance items to match split main products
          // Each insurance item should match its corresponding main product's UUID and setNumber
          // UUID is the same for all items in a pair/triplet (old logic)
          // setNumber is unique per pair/triplet
          var newInsuranceItemsToAdd = newLineItemsDataProperties.map((mainProductProps, index) => {
            return {
              id: product_id,
              quantity: 1,
              properties: {
                ...itemToAdd.properties,
                _uuid: mainProductProps._uuid, // Same UUID for all items in pair/triplet (old logic)
                _set_number: mainProductProps._set_number, // Unique setNumber per pair/triplet
                ...(mainProductProps._bundle_set_number && { _bundle_set_number: mainProductProps._bundle_set_number }),
              },
            };
          });

          var resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "post",
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              items: newInsuranceItemsToAdd,
            }),
          });
        } else if (shouldSplitIntoIndividualItems && additional_flag == "gwp") {
          // GWP splitting logic (existing)
          var newGwpLineItemProperties = Array.from(Array(parseInt(itemToAdd.quantity))).map((_, index) => {
            return {
              ...itemToAdd.properties,
              _uuid: newItemsToAdd[index].properties._uuid,
            };
          });

          var newGwpItemsToAdd = newGwpLineItemProperties.map((properties) => {
            return {
              id: product_id,
              quantity: itemToAdd.quantity / newGwpLineItemProperties.length,
              properties,
            };
          });

          var resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "post",
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              items: newGwpItemsToAdd,
            }),
          });
        } else {
          var resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "post",
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              items: [itemToAdd],
            }),
          });
        }

        if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
          var d = await resp.json();
          // when a gwp adds a discount to the CTO product, the item key for the CTO product may change
          if (d.items?.some((item) => item.discounts?.length)) {
            var cartData = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json());
            var newCTOItem = cartData.items.find((item) => item.properties?._cto_product && item.properties?._uuid === newCTOItemUuid);
            var newCTOItemKey = newCTOItem?.key;
            $CTOcartDrawer[0].updateCtoItemKey(newCTOItemKey);
          }
          // small delay to ensure CTO cart refresh does not have a race condition with main cart refresh
          window.setTimeout(function(){$CTOcartDrawer[0].updateItems(d.items);},100);
        }

        window.onCartUpdate();
        // Wedev: lets the "added to cart" panel (wd-cart-added-panel.js) re-render after a warranty / GWP add
        document.dispatchEvent(new CustomEvent('wd:care-added', { detail: { reference: additional_flag, mainProductKey: main_product_key, setNumber: setNumber } }));
    });
    /*Add Applecare on cart page functionality  ends here - added by Hema*/

    /*
    	Add Trade-In on cart page
    */
    $(document).on('click', '.add-cart-trade-in', function(e) {
      e.preventDefault();
      $(this).prop('disabled', true);

      if (window.toggleAddOnButtons) window.toggleAddOnButtons('disable');
      const add_button = $(this);
      const tradeInValue = add_button.data('tradeInValue');
      const tradeInDevice = add_button.data('tradeInDevice');
      const tradeInSetNumber = add_button.data('tradeInSetNumber');
      const main_product_id = add_button.data('parentId');
      const main_product_index = add_button.data('forproduct');
      const main_product_parent = $(`#${main_product_id}`);
      const main_product_quantity = main_product_parent.find('.quantity__input').val();
      const main_product_sku = add_button.data('skuparent');
      const main_product_handle = add_button.data('handleparent');
      const main_product_preorder = add_button.data('preorderparent');
      const main_product_preorder_message = add_button.data('preordermessageparent');
      const main_product_trade_in = add_button.data('tradeinparent');
      const main_product_key = add_button.data('keyparent');
      const main_mpn_value = add_button.data('mpnparent');
      const additional_flag = add_button.data('reference')
      const main_product_tags = main_product_parent.find('.cart_tax_tags').val();

      let properties = $(this).data('itemProperties');

      if (main_product_preorder) properties._preOrder = 'true';
      if (main_product_preorder_message) properties._preOrderMessage = main_product_preorder_message;
      if (tradeInDevice) properties._tradeInEligible = 'true';
      // if (tradeInValue) properties._tradeIn_value = tradeInValue.toString().replace('.', '');
      // if (tradeInDevice) properties._tradeIn_device = tradeInDevice;
      if (tradeInSetNumber) properties._trade_in_set_number = tradeInSetNumber;
      // if (tradeInDevice && properties._uuid && !properties._uuid.includes('tradein')) {
      //   properties._uuid = properties._uuid + '-tradein';
      // }

      // *** UNCOMMENT AFTER QUANTITY SELECTOR IS ADDED *** //
      // const data_tradeIn = `{
      //   "line": ${main_product_index},
      //   "quantity": ${main_product_quantity,
      //   "properties": ${JSON.stringify(properties)}
      // }`;

      // *** TEMPORARY *** //
      // Remove after quantity selector is added
      const data_tradeIn = `{
        "line": ${main_product_index},
        "quantity": ${main_product_quantity || 1},
        "properties": ${JSON.stringify(properties)}
      }`;

      $.ajax({
        url: `${window.Shopify.routes.root}cart/change.js`,
        type: "POST",
        data: data_tradeIn,
        contentType: "application/json",
        dataType: 'json',
        success: function(data) {
          const oldUuid = properties?._uuid.split('-tradein')[0];
          const newUuid = properties?._uuid;

          if (!oldUuid || !newUuid || oldUuid === newUuid) return;

          const appleCareProductsThatNeedUpdating = data.items.find(item => item.properties?._aplcr_main_product_sku && item.properties?._uuid === oldUuid);
          const secWarrantyProductsThatNeedUpdating = data.items.find(item => item.properties?._sw_main_product_sku && item.properties?._uuid === oldUuid);
          const gwpProductsThatNeedUpdatingArr = data.items.filter(item => item.properties?._gwp_main_product_sku && item.properties?._uuid === oldUuid);

          async function updateAcSecProducts() {
            if (appleCareProductsThatNeedUpdating) {
              const newProperties = { ...appleCareProductsThatNeedUpdating.properties, _uuid: newUuid };
              const line = data.items.findIndex(item => item.key === appleCareProductsThatNeedUpdating.key) + 1;
              const newData = {
                line,
                quantity: appleCareProductsThatNeedUpdating.quantity,
                properties: newProperties,
              };
              await fetch(`${window.Shopify.routes.root}cart/change.js`, {
                method: "POST",
                headers: {
                  'content-type': 'application/json'
                },
                body: JSON.stringify(newData),
              });
            }

            if (secWarrantyProductsThatNeedUpdating) {
              const newProperties = { ...secWarrantyProductsThatNeedUpdating.properties, _uuid: newUuid };
              const line = data.items.findIndex(item => item.key === secWarrantyProductsThatNeedUpdating.key) + 1;
              const newData = {
                line,
                quantity: secWarrantyProductsThatNeedUpdating.quantity,
                properties: newProperties,
              };
              await fetch(`${window.Shopify.routes.root}cart/change.js`, {
                method: "POST",
                headers: {
                  'content-type': 'application/json'
                },
                body: JSON.stringify(newData),
              });
            }

            if (gwpProductsThatNeedUpdatingArr.length) {
              for (const gwpProductsThatNeedUpdating of gwpProductsThatNeedUpdatingArr) {
                const newProperties = { ...gwpProductsThatNeedUpdating.properties, _uuid: newUuid };
                const line = data.items.findIndex(item => item.key === gwpProductsThatNeedUpdating.key) + 1;
                const newData = {
                  line,
                  quantity: gwpProductsThatNeedUpdating.quantity,
                  properties: newProperties,
                };
                await fetch(`${window.Shopify.routes.root}cart/change.js`, {
                  method: "POST",
                  headers: {
                    'content-type': 'application/json'
                  },
                  body: JSON.stringify(newData),
                });
              }
            }

            location.reload();
          }

          updateAcSecProducts();
        },
        error: function(xhr, status, error) {
          console.log(`Error: ${xhr.responseText}`);
        }
      });
    });

    /* sticky atc on pdp functionality  starts here - added by Hema*/
  $(document).on('click', '#footer-atc, #eilat-booking', function (evt) {
    evt.preventDefault();
    /* Order Product Limits - Karthikeyan */
    var prodVariantID = $("#main-product-variant").val();
    var prodQuant = $("#prodQuantity").val();
    var total_qty = $("#total_qty_" + prodVariantID).val();
    /* VAT Product Limits - Karthikeyan */
    const isValidQty = checkQty();
    // check if the additional bundle products are in the cart - WeDev START
    const additionalBundleProducts = $("#footer-atc").data('additional-bundle-products') || null;
    const additionalBundleProductsEilat = $("#footer-atc").data('additional-bundle-products-eilat') || null;

    // check if the additional bundle products are in the cart - WeDev END

    if (!isValidQty) {
      return false;
    }

    // wedev edit: added functionally to #eilat-booking (same as regualr btn but with eilat flag)
    var isEilat = this.id === 'eilat-booking';
    var asMode = isEilat ? 'eilat' : 'regular';

        if (vat_free_day == true) {
            var taxtags = $("#tax_tags").val();
            var prodQuant = $("#prodQuantity").val();
            var addtaxfree = taxtags.indexOf('taxfree') != -1;
            if (getCookie('total_quantity') == "") {
                var tax_total_quantity = parseInt(prodQuant);
            } else {
                var tax_total_quantity = parseInt(prodQuant) + parseInt(getCookie('total_quantity'));
            }

            if (addtaxfree == true) {
                if (tax_total_quantity > vat_free_quantity) {
                    alert(vat_free_message);
                    return false;
                } else {
                  addToCart("cart", additionalBundleProducts, additionalBundleProductsEilat, asMode);
                }
            } else {
              addToCart("cart", additionalBundleProducts, additionalBundleProductsEilat, asMode);
            }
        } else {
          addToCart("cart", additionalBundleProducts, additionalBundleProductsEilat, asMode);
        }
        return false;
    });


    $(document).on('click', '.js-checkout-button,.js-checkout-link', function(evt) {
      evt.preventDefault();
      //   var tttype = $(".shopify-payment-button__button").attr("type");
      var prodVariantID = $("#main-product-variant").val();
      var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
      const isValidQty = checkQty();

      if (!isValidQty) {
        return false;
      }
      if (vat_free_day == true) {
        var taxtags = $("#tax_tags").val();
        var prodQuant = $("#prodQuantity").val();
        var addtaxfree = taxtags.indexOf('taxfree') != -1;

        if (getCookie('total_quantity') == "") {
          var tax_total_quantity = parseInt(prodQuant);
        } else {
          var tax_total_quantity = parseInt(prodQuant) + parseInt(getCookie('total_quantity'));
        }

        if (addtaxfree == true) {
          if (tax_total_quantity > vat_free_quantity) {
            alert(vat_free_message);
            return false;
          }
        }
      }
      if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
        var proliststring = $(".pdp_product_list").attr("value");
      } else {
        var proliststring = formatString($(".pdp_product_list").attr("value"));
      }
      var productList = proliststring;
      // cartCookie(mpn_handle, prodVariantID, productList);

      $('.js-checkout-button,.js-checkout-link').attr('disabled', true);
      addToCart("buy");
    });

    /* sticky atc on pdp functionality  ends here - added by Hema*/



    /* WD ADD FUNCTION PARAMETERS - START */
  async function addToCart(check_buy, additionalBundleProducts = null, additionalBundleProductsEilat = null, asMode = 'regular') {
    //WD ADD FUNCTION PARAMETERS - START
      var $cartDrawer = document.querySelector('cart-drawer') || null;
      var $CTOcartDrawer = $('cto-cart-drawer');
      var isCTO = event?.target?.dataset.ctoProduct === 'true'
        || event?.target?.closest('.js-checkout-button,.js-checkout-link')?.dataset.ctoProduct === 'true'
        || false;
      var taxtags = $("#tax_tags").val();
      var btn = $(this).find(".BUY_NOW_CLICKED");
      var buy_now_checker = btn.data('submit');
      /* Applecare PDP - one warranty per product: main (Apple Care) OR second warranty, not both */
      var isChecked = $('#add-apple-care').is(':checked');
      var isChecked2 = $('#add-secWarranty').is(':checked');
      if (isChecked && isChecked2) {
        isChecked2 = false;
        $('#add-secWarranty').prop('checked', false);
      }
      var hasGwp = $('.js-gwp-data').length > 0;
      var gwpMaximum = $('.js-gwp-data').data('gwp-maximum');
      var hasTradeIn = $('#selected-trade-in-value').val() !== undefined && $('#selected-trade-in-value').val() !== '0' && $("#selected-trade-in-device").val() !== '';
      const tradeInValue = $("#selected-trade-in-value").val() || ''; // Get Trade-In value
      const parsedTradeInValue = hasTradeIn ? parseInt(tradeInValue).toFixed(2).replace('.', '') : null; // Set parsed Trade-In value
      const tradeInDevice = $("#selected-trade-in-device").val() || ''; // Get Trade-In value
      var prodVariantID = $('#main-product-variant').val();
      var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
      var productcomPrice = $("#compr_price_" + prodVariantID).val();
      var uuid = Math.random().toString(36).slice(2);

      const disablePdpButton = (disable) => {
        if (check_buy === 'cart') {
          document.querySelectorAll(".show_atc button").forEach(button => {
            if (disable)
              button.setAttribute('disabled', true);
            else
              button.removeAttribute('disabled');
          });
        }
      }

    const adobeTrack = (items) => {
      if (typeof adobeTrackAddToCart === 'function') 
        adobeTrackAddToCart({
          items,
          context: check_buy === 'cart' ? 'PDP Add to Cart' : 'Check out with Apple Pay',
          $trigger: check_buy === 'cart' ? $('#footer-atc')[0] : null,
          triggerText: check_buy !== 'cart' ? 'Check out with Apple Pay' : null,
          triggerUrl: check_buy !== 'cart' ? `${window.location.origin}${window.Shopify.routes.root}checkout` : null,
        });
      }

      disablePdpButton(true);

      var applecareID = $("#apple-care-varid").val(); //Getting apple care id
      var applecaresku = $("#applecare-product-sku").val(); //Getting apple care sku
      var applecarehandle = $("#applecare-product-handle").val(); //Getting apple care handle
      var $footerAtc = $('#footer-atc');
      var defaultlyGivenWarrantyId = $footerAtc.data('defaultlyGivenWarranty') || null;
      if (!isChecked && !isChecked2 && defaultlyGivenWarrantyId) {
        isChecked = true;
        applecareID = defaultlyGivenWarrantyId;
        applecaresku = $footerAtc.data('defaultlyGivenWarrantySku') || '';
        applecarehandle = $footerAtc.data('defaultlyGivenWarrantyHandle') || '';
      }
      var secWarrantyID = $("#secWarranty-varid").val(); //Getting secWarranty id
      var secWarrantysku = $("#secWarranty-product-sku").val(); //Getting secWarranty sku
      var secWarrantyhandle = $("#secWarranty-product-handle").val(); //Getting secWarranty handle
      var gwpData = $('.js-gwp-data'); //Getting gwp data
      var main_product_sku = $("#main-pro-sku").val(); //Getting MAIN PRODUCT SKU
      var main_product_handle = $("#main-pro-handle").val(); //Getting main product handle
      var main_product_preorder = $("#main-pro-preorder").val(); //Getting main product preorder value
      var main_product_preorder_message = $("#main-pro-preorder-message").val(); //Getting main product preorder message value
      var main_product_prerelease_property = $("#main-pro-preorder").data('prereleaseProperty') || '_preOrder';
      var main_product_trade_in = $("#main-pro-trade-in").val(); //Getting main product trade-in value
      var prodVariantID = $('#main-product-variant').val(); //Getting main product id
      var prodQuant = $("#prodQuantity").val(); //Getting main product QUANTITY
      var uid = main_product_handle;
      var gwpKey = btoa(Math.random());
      const setNumber = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
      const activeBundleProducts = asMode === 'eilat'
        ? (additionalBundleProductsEilat || []).filter((id) => id && String(id).trim())
        : (additionalBundleProducts || []).filter((id) => id && String(id).trim());
      // Stack ATC repeats only for plain bundles (no warranty/trade-in). Gift/selected/bundled care → random set.
      // Bundled Care ships as _isBundleProduct (ICARE-*), so Liquid stamps data-bundle-includes-warranty.
      var bundleIncludesWarranty = $footerAtc.attr('data-bundle-includes-warranty') === 'true'
        || !!defaultlyGivenWarrantyId;
      const bundleBlocksStacking = (isChecked == true || isChecked2 == true)
        || bundleIncludesWarranty
        || !!(window.isAddtradeInProduct && window.tradeInProductToAdd);
      const bundleSetNumber = activeBundleProducts.length > 0
        ? (bundleBlocksStacking
          ? Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10)
          : String(prodVariantID))
        : null;

      if (isChecked == true) {
        uid = uid + '-' + applecarehandle;
      }
      if (isChecked2 == true) {
        uid = uid + '-' + secWarrantyhandle;
      }
      if (hasGwp) {
        uid = uid + '-' + gwpKey;
      }
      // if (tradeInDevice && !uid.includes('tradein')) {
      //   uid = uid + '-tradein';
      // }

      const props = {
        _uuid: uid,
        ...(main_product_preorder === 'true' && { [main_product_prerelease_property]: 'true' }),
        ...(main_product_preorder_message && { [main_product_prerelease_property + 'Message']: main_product_preorder_message }),
        ...(main_product_trade_in === 'true' && { _tradeInEligible: 'true' }),
      };

      if (isChecked == true) {
        props._applecare_sku = applecaresku;
        props._applecare_handle = applecarehandle;
        props._set_number = setNumber;
        // Gift warranty (defaultly_given) must stay 1:1 on cart + — not bare-stacked
        if (defaultlyGivenWarrantyId) props._gift_warranty = 'true';
      }

      if (isChecked2 == true) {
        props._secWarranty_sku = secWarrantysku;
        props._secWarranty_handle = secWarrantyhandle;
        props._set_number = setNumber;
      }

      if (isCTO) {
        props._cto_product = 'true';
      }

      if (hasGwp) {
        var gwpSkus = [];
        var gwpHandles = [];
        gwpData.each(function() {
          gwpSkus.push($(this).data('gwp-product-sku'));
          gwpHandles.push($(this).data('gwp-product-handle'));
        });
        props._gwp_sku = gwpSkus.join(',');
        props._gwp_handle = gwpHandles.join('-');
      }

      if (hasTradeIn === true) {
        // props._tradeIn_value = parsedTradeInValue;
        // props._tradeIn_device = tradeInDevice;
        props._tradeInEligible = 'true';
      }

      var items = [
        {
          id: prodVariantID,
          quantity: prodQuant,
          properties: props,
          product_type: $('.pdp_product_category').val() || ''
        }
      ];

      if (isChecked == true) {
        items.push({
          id: applecareID,
          quantity: prodQuant,
          properties: {
            _aplcr_main_product_sku: main_product_sku,
            _aplcr_main_product_handle: main_product_handle,
            _uuid: uid,
            _set_number: setNumber,
            // Link gift/selected warranty into the bundle group when present so we could add it when cart quantity changes
            ...(bundleSetNumber && { _bundle_set_number: bundleSetNumber }),
            ...(defaultlyGivenWarrantyId && { _gift_warranty: 'true' }),
          }
        });
      }
      //WD ADD BUNDLE PRODUCTS PARAMETERS - START
      activeBundleProducts.forEach((variantId) => {
        items.push({
          id: variantId,
          // Bundle qty tracks parent qty; split path below emits one child per parent unit
          quantity: prodQuant,
          properties: {
            _isBundleProduct: 'true',
            _bundle_set_number: bundleSetNumber,
          },
        });
      });
      //WD ADD BUNDLE PRODUCTS PARAMETERS - END
      if (isChecked2 == true) {
        items.push({
          id: secWarrantyID,
          quantity: prodQuant,
          properties: {
            _sw_main_product_sku: main_product_sku,
            _sw_main_product_handle: main_product_handle,
            _uuid: uid,
            _set_number: setNumber,
            ...(bundleSetNumber && { _bundle_set_number: bundleSetNumber }),
          }
        });
      }

      if (hasGwp) {
        gwpData.each(function() {
          items.push({
            id: $(this).data('gwp-id'),
            quantity: Math.min($(this).data('gwp-quantity') * prodQuant, gwpMaximum || 0),
            properties: {
              _gwp_main_product_sku: main_product_sku,
              _gwp_main_product_handle: main_product_handle,
              _uuid: uid
            }
          });
        });
      }

      const adobeItems = [
        {
          id: secWarrantyID,
          quantity: prodQuant,
        },
        {
          id: applecareID,
          quantity: prodQuant,
        },
        {
          id: prodVariantID,
          quantity: prodQuant,
        }
      ];

      // Split into individual items when quantity > 1 AND (insurance / GWP / trade-in / bundled ICARE)
      // Each pair/triplet (product + insurance/insurances) gets its own setNumber for order sync app
      // UUID remains the same for all items in a pair/triplet (old logic)
      // For trade-in: only first item gets trade-in, others can have it added later
      // Bundled ICARE (data-bundle-includes-warranty) must also split so each unit gets its own _bundle_set_number
      const hasInsurance = isChecked == true || isChecked2 == true;
      var hasTradeIn = window.isAddtradeInProduct && window.tradeInProductToAdd;
      const shouldSplitIntoIndividualItems = parseInt(prodQuant) > 1 && (hasInsurance || hasGwp || hasTradeIn || bundleIncludesWarranty);
      
      // Generate trade-in set number if trade-in is being added
      // Only first item will get this set number when quantity > 1
      const tradeInSetNumber = hasTradeIn 
        ? Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10)
        : null;
      
      const newItemsToAdd = [];
      if (shouldSplitIntoIndividualItems) {
        // Generate unique setNumbers for each pair/triplet
        const newSetNumbers = Array.from(Array(parseInt(prodQuant))).map(() => {
          return Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
        });
        // Unique bundle set per parent unit so bundle stay 1:1 owith unique set numbers
        const newBundleSetNumbers = bundleSetNumber
          ? Array.from(Array(parseInt(prodQuant))).map(() => {
            return Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
          })
          : null;

        // For GWP, generate unique UUIDs per item (old GWP logic)
        // For insurance, keep the same UUID for all items in a pair/triplet
        const newUuids = Array.from(Array(parseInt(prodQuant))).map((_, index) => {
          if (hasGwp && !hasInsurance) {
            // GWP only: use old logic with unique UUIDs
            if (gwpMaximum && index >= gwpMaximum) {
              return uid.replace(`-${gwpKey}`, '');
            }
            return uid.replace(`-${gwpKey}`, `-${btoa(Math.random())}`);
          }
          // Insurance: keep same UUID for all items in pair/triplet (old logic)
          return uid;
        });

        items.forEach((item) => {
          Array.from(Array(parseInt(item.quantity))).forEach((_, index) => {
            let newUuid = newUuids[index];
            let newSetNumber = newSetNumbers[index];
            const isBundleChild = item.properties?._isBundleProduct === 'true';
            const isWarranty = !!(item.properties?._aplcr_main_product_sku || item.properties?._sw_main_product_sku);
            const isMain = String(item.id) === String(prodVariantID);

            // Build properties for this individual item
            let newProperties = {
              ...item.properties,
            };
            // Bundle children keep only bundle props — no parent uuid/set_number leakage
            if (!isBundleChild) {
              newProperties._uuid = newUuid; // Keep same UUID for all items in pair/triplet
            } else {
              delete newProperties._uuid;
              delete newProperties._set_number;
            }
            
            // Update setNumber for all items (main product and insurance) when insurance is selected
            if (!isBundleChild) {
              if (hasInsurance) {
                newProperties._set_number = newSetNumber;
              } else if (item.properties._set_number) {
                // Keep existing setNumber if no insurance
                newProperties._set_number = item.properties._set_number;
              }
            }
            
            // Add trade-in set number only to first item when trade-in is being added
            if (tradeInSetNumber && index === 0 && isMain) {
              newProperties._trade_in_set_number = tradeInSetNumber;
            }
            // Note: Items with index > 0 should NOT have _trade_in_set_number (they can have trade-in added later)

            // Main, bundle children, and warranty share this unit's bundle set number
            if (newBundleSetNumbers && (isMain || isBundleChild || isWarranty)) {
              newProperties._bundle_set_number = newBundleSetNumbers[index];
            }
            
            newItemsToAdd.push({
              id: item.id,
              quantity: 1,
              properties: newProperties,
            });
          });
        });
      } else {
        const mainItem = items.find((item) => String(item.id) === String(prodVariantID));
        if (mainItem?.properties) {
          if (tradeInSetNumber) {
            mainItem.properties._trade_in_set_number = tradeInSetNumber;
          }
          if (bundleSetNumber) {
            mainItem.properties._bundle_set_number = bundleSetNumber;
          }
        }
      }

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      buyMode: asMode,
        method: "post",
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(shouldSplitIntoIndividualItems ? {items: newItemsToAdd} : {items}),
      })
        .then(response => {
          response.json().then(async d => {
            if (d.status === 422) {
              console.error('Error:', d.message);
              return false;
            }

            // WD ADD TRADE-IN PARAMETERS - START
            if (window.isAddtradeInProduct && window.tradeInProductToAdd && tradeInSetNumber) {
              // Find the first main product item (the one with trade_in_set_number)
              // When quantity > 1, items were split, so we need to find the one with _trade_in_set_number
              const mainProductWithTradeIn = shouldSplitIntoIndividualItems 
                ? d.items.find(item => item.properties?._trade_in_set_number === tradeInSetNumber)
                : d.items[0];
              
              if (mainProductWithTradeIn) {
                const tradeInProductCart = {
                  id: `${window.tradeInProductToAdd.variantId}`,
                  quantity: 1,
                  properties: {
                    _isTradeInProduct: 'true',
                    _tradeIn_value: window.tradeInProductToAdd.price,
                    _tradeIn_model: window.tradeInProductToAdd.tradeInModel,
                    _tradeIn_condition: window.tradeInProductToAdd.tradeInCondition,
                    _tradeIn_capacity: window.tradeInProductToAdd.tradeInCapacity,
                    _tradeIn_brand: window.tradeInProductToAdd.brand,
                    _trade_in_set_number: tradeInSetNumber,
                  }
                }
                await addTradeInProductToCart(tradeInProductCart)
              }
            }
            // WD ADD TRADE-IN PARAMETERS - END
            if ($(".pdp_product_list").attr("value").indexOf('PLP ::') >= 0) {
              var proliststring = $(".pdp_product_list").attr("value");
            } else {
              var proliststring = formatString($(".pdp_product_list").attr("value"));
            }
            var productList = proliststring;

            removeGwpData(gwpData);

            if (isChecked == true || isChecked2 == true || hasTradeIn === true) {
              if (isChecked == true && isChecked2 == true) {
                if (d?.items?.length > 2) {
                  cartCookie(mpn_handle, d.items[2].key, productList);
                }
              } else if (isChecked == false && isChecked2 == true) {
                if (d?.items?.length > 1) {
                  cartCookie(mpn_handle, d.items[1].key, productList);
                }
              } else if (isChecked == true && isChecked2 == false) {
                if (d?.items?.length > 1) {
                  cartCookie(mpn_handle, d.items[1].key, productList);
                }
              } else if (hasTradeIn === true) {
                if (d?.items?.length) {
                  cartCookie(mpn_handle, d.items[0].key, productList);
                }
              }
            } else {
              if (d?.items?.length) {
                cartCookie(mpn_handle, d.items[0].key, productList);
              }
            }

            triggerGAAddToCart(productcomPrice, mpn_handle, productTitle, productCategory, productList, productCurrency, productPrice, prodQuant, main_product_sku, prodVariantID);
            if ($cartDrawer && !isCTO) {
              // Wedev: the PDP add opens the "added to cart" panel, which refreshes the drawer without opening it (falls back to the drawer)
              const $addedPanel = document.querySelector('wd-cart-added-panel');
              if ($addedPanel && check_buy === 'cart') {
                $addedPanel.openForAdd({ items: d.items, variantId: prodVariantID, handle: main_product_handle });
              } else {
                $cartDrawer.updateItems();
              }
            }
            if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
              $CTOcartDrawer[0].updateItems(d.items);
            }

            adobeTrack(adobeItems);
          })
          if (check_buy == "buy") {
            $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
              var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
              if ($('.cart-count-bubble').length > 0) {
                $('.cart-count-bubble span').text(item_count);
              } else {
                $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
                $('.cart-count-bubble span').text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);

              if (!$CTOcartDrawer.length || $CTOcartDrawer.hasClass('hidden')) {
                $('#cart-notification').addClass('minicart-active');
              }
              $("#cart-notification").css("visibility", "hidden");
              $(".cart-count-bubble").css("visibility", "hidden");
              window.location.href = `${window.Shopify.routes.root}checkout`;
            });
          } else {
            $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
              var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
              if ($('.cart-count-bubble').length > 0) {
                $('.cart-count-bubble span').text(item_count);
              } else {
                $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
                $('.cart-count-bubble span').text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);

              if (!$CTOcartDrawer.length || $CTOcartDrawer.hasClass('hidden')) {
                $('#cart-notification').addClass('minicart-active');
              }
            });
            var main_product_sku = $("#main-pro-sku").val();
            var productCategory = $(".pdp_product_category").attr("value");
            var productCurrency = $(".pdp_product_currency").attr("value");
            var productPrice = $("#prod_price_" + prodVariantID).val();
            var productTitle = $(".pdp_product_title").attr("value");
            var prodQuant = $("#prodQuantity").val();
          }
          disablePdpButton(false);
        })
        .catch((error) => {
          console.error('Error:', error);
          return false;
        })
        .finally(() => {
          disablePdpButton(false);
        });
    }

    function removeGwpData(gwpData) {
      const metaobjectIds = [];
      gwpData.each(function() {
        metaobjectIds.push($(this).data('gwp-metaobject-id'));
      });

      metaobjectIds.forEach((id) => {
        $(`.js-gwp-data[data-gwp-metaobject-id="${id}"], .js-slider-form-gwp-data[data-gwp-metaobject-id="${id}"]`).remove();
      });
    }

    function cartCookie(mpn_handle, prodVariantID, productList) {
        var prevPage = document.referrer;
        var search_value = '';
        var first_search = '';
        if (prevPage.includes("search")) {
            first_search = localStorage.getItem("search_value");
            search_value = localStorage.getItem("search_value_term");
            if (first_search == null) {
                localStorage.setItem("search_value", search_value);
                var first_search_str = localStorage.getItem("search_value");
                first_search = formatString(first_search_str);
            }
        }
        var exphone = [];
        var item_cart = {}
        item_cart["cart_item_id"] = prodVariantID;
        item_cart["cart_item_list_name"] = productList;
        item_cart["cart_item_mpn"] = mpn_handle;
        item_cart["cart_search_term"] = first_search;
        if (JSON.parse(localStorage.getItem("cart")) != null) {
            exphone = JSON.parse(localStorage.getItem("cart"));
        }
        exphone.push(item_cart);
        localStorage.setItem("cart", JSON.stringify(exphone));
        // console.log(JSON.parse(localStorage.getItem("cart")));
    }

    function triggerGAAddToCart(productcomPrice, mpn, productTitle, productCategory, productList, productCurrency, productPrice, prodQuant, main_product_sku, prod_variantID) {
        var prevPage = document.referrer;
        var search_value = '';
        if (prevPage.includes("search")) {
            var first_search = localStorage.getItem("search_value");
            search_value = localStorage.getItem("search_value_term");
            if (first_search == null) {
                localStorage.setItem("search_value", search_value);
                var first_search_str = localStorage.getItem("search_value");
                first_search = formatString(first_search_str);
            }
        }
        dataLayer.push({
            'ecommerce': null
        });
        productPrice = Number(productPrice?.replace(/[^0-9.-]+/g, ""));
        var value_price = productPrice * parseInt(prodQuant);
        var discount = 0;
        var value_price1 = parseFloat(value_price);
        var productPrice1 = parseFloat(productPrice);
        dataLayer.push({
            'event': 'add_to_cart',
            'search_term': search_value,
            'currency': productCurrency,
            'value': value_price1,
            'ecommerce': {
                'items': [{
                    'item_id': mpn,
                    'item_name': productTitle,
                    'item_category': productCategory,
                    'item_list_name': productList,
                    'price': productPrice1,
                    'quantity': parseInt(prodQuant)
                }]
            }
        });
    }


    function formatString(str) {
      if (!str) return '';
        return str
            .replace(/(\B)[^ ]*/g, match => (match.toLowerCase()))
            .replace(/^[^ ]/g, match => (match.toUpperCase()));
    }

    /* Minicart starts here - added by Hema*/
    function miniCart() {
        $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
            $('cart-notification').replaceWith(itemData);
            $('#cart-notification').addClass('minicart-active');
            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: `${window.Shopify.routes.root}cart.js`,
                success: function(cart) {
                    let total = cart.item_count;
                    $('.cart-count-bubble').text(total);
                }
            });

        });
    }

    if ($productGrid) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation?.type === 'childList') {
            // reinit quick add buttons
            quickAddEvents();
          }
        });
      });
      observer.observe($productGrid, { childList: true });
    }

    $("#prodQuantity").on("change", function() {
      debounce(checkQty, 500)();
    });

    function checkQty() {
      var productId = $("#product_id").val();
      var productQty = $("#prodQuantity").val();
      var prodMaxQty = $("#product_max_quantity").val();
      var prodInventoryQuantity = $("#productInventoryQuantity").val();
      var $errorMessage = document.querySelector('.js-qty-error') || null;
      var $qtyInput = document.querySelector('.js-qty-input') || null;
      var $pickUpAvailability = document.querySelectorAll('pickup-availability') || null;
      var $storeLocator = document.querySelector('my-store-locator') || null;

      if ($storeLocator && $pickUpAvailability?.length > 0 && productQty) {

        [...$pickUpAvailability].forEach((el) => {
          var locationId = $storeLocator.preferredStoreId || null;
          el.dataset.itemQuantity = productQty ? parseInt(productQty) : null;

          if (locationId) {
            var location = $storeLocator?.allLocationsData?.find((loc) => loc.id === locationId) || null;
            if (location) {
              el.renderPreview(location);
            }
          }
        });
      }

      var maxQty = checkMaxquantity(productId);

      if (maxQty != "") {
          var maxQtyAllowed = parseInt(productQty) + parseInt(maxQty);
      } else {
          var maxQtyAllowed = parseInt(productQty);
      }

      if (maxQtyAllowed > prodMaxQty) {
        if ($errorMessage) {
          const text = $errorMessage.innerHTML;

          if (text) {
            if (text.includes('{limit}')) {
              $errorMessage.innerHTML = text.replace('{limit}',`(${prodMaxQty})`);
              $errorMessage.classList.remove('hidden');
            } else {
              // scroll to the error message WEDEV - START
              $qtyInput.scrollIntoView({ behavior: 'smooth' });
              // scroll to the error message WEDEV - END
              $errorMessage.classList.remove('hidden');
            }
          }
        }
        if ($qtyInput) {
          $qtyInput.classList.add('quantity--error');
        }
        return false;
      } else if (maxQtyAllowed > parseInt(prodInventoryQuantity)) {
        if ($errorMessage) {
          const maxLevel = parseInt(prodInventoryQuantity);
          const text = $errorMessage.innerHTML;

          if (text) {
            if (text.includes('{limit}')) {
              $errorMessage.innerHTML = text.replace('{limit}', `(${maxLevel})`);
              $errorMessage.classList.remove('hidden');
            } else {
              // scroll to the error quantity input + add WEDEV - START
              $qtyInput.scrollIntoView({ behavior: 'smooth',block: 'center' });
              // scroll to the error quantity input + add WEDEV - END
              $errorMessage.classList.remove('hidden');
            }
          }
        }

        if ($qtyInput) {
          $qtyInput.classList.add('quantity--error');
        }
        return false;
      } else {
        resetErrors();
        return true;
      }
    }

    function resetErrors() {
      var $errorMessage = document?.querySelector('.js-qty-error') || null;
      var $qtyInput = document?.querySelector('.js-qty-input') || null;

      if ($errorMessage) {
        $errorMessage.classList.add('hidden');
      }
      if ($qtyInput) {
        $qtyInput.classList.remove('quantity--error');
      }
    }
});
/* Minicart ends here - added by Hema*/


function checkMaxquantity(product_id) {
    var total_max_quantity = 0;
    var product_id = product_id;
    $.ajax({
        type: 'GET',
        dataType: 'json',
        async: false,
        url: `${window.Shopify.routes.root}cart.js`,
        success: function(cart) {
            for (var i = 0; i < cart.items.length; i++) {
                var product_cartid = cart.items[i].product_id;
                if (product_cartid == product_id) {
                    total_max_quantity += cart.items[i].quantity;
                }
            }
        }
    });
    return total_max_quantity;
}

function checkQuantity() {
    var total_quantity = 0;
    var cart_key = [];
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: `${window.Shopify.routes.root}cart.js`,
        success: function(cart) {
            for (var i = 0; i < cart.items.length; i++) {
                var tags = cart.items[i].properties.__taxtags;
                if (tags != undefined) {
                    var list = tags.split(',');
                    var found = false;
                    for (var j = 0; j < list.length; ++j) {
                        cart_key.push(cart.items[i].properties.__taxtags);
                        if (list[j] == 'taxfree') {
                            total_quantity += cart.items[i].quantity;
                        }
                    }
                }
            }
            setCookie('total_quantity', total_quantity, 7);
            setCookie('cart_key', cart_key, 7);
        }
    });
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
async function addTradeInProductToCart(tradeInProduct) {
  return await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "post",
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({items: [tradeInProduct]}),
  }).then(response => {
    response.json().then(d => {
      if(!response.ok) {
        console.error('Error:', d.message);
        return false;
      }
    })
  })
  .catch(error => {
    console.error('Error:', error);
    return false;
  })
  .finally(() => {
    window.isAddtradeInProduct = false;
    window.tradeInProductToAdd = null;
  });
}

function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
